module.exports = __webpack_public_path__ + "img/danmogot.80626a77.png";